package com.parmartechnologies.core.engine.pricing

import com.parmartechnologies.core.feature.product.model.ProductPrice
import com.parmartechnologies.core.feature.sale.model.Sale
import com.parmartechnologies.core.engine.math.MathEngine
import kotlin.time.ExperimentalTime


class PricingEngine {

    @OptIn(ExperimentalTime::class)
    fun calculateInvoicePrice(saleItems: List<Sale>?): ProductPrice {
        var totalTax = 0.0
        var totalFinalPrice = 0.0
        var totalSalePrice = 0.0
        val pricingDetails = ProductPrice()
        saleItems?.forEach { sale ->
            totalFinalPrice += sale.FinalPrice
            totalTax += sale.Tax
            totalSalePrice += sale.SalePrice * sale.Quantity
        }
        pricingDetails.Tax = totalTax
        pricingDetails.FinalPrice = totalFinalPrice
        pricingDetails.SalePrice = totalSalePrice
        return pricingDetails
    }

    fun computePercentToValue(Amount: Double?, percentValue: Double?): Double {
        return (Amount!! * percentValue!!)/100
    }

    fun calculateTax(taxIncluded: Boolean, amount: Double, totalTaxPercent: Double): Double {
        val taxedAmount = if (taxIncluded) {
            (amount * totalTaxPercent) / (totalTaxPercent + 100)
        } else {
            computePercentToValue(amount, totalTaxPercent)
        }
        return MathEngine().roundTo(taxedAmount, 2)
    }

}